import { Employe } from "./Employe";
import { DateUtils } from "../utils/DateUtils";
import _ from "lodash";

export class BulletinDeSalaire {
    id?: number;
    employe_id?: number;
    _employe?: Employe;
    employe_name?: string;
    month?: string;
    total_brut?: number;
    total_net?: number;
    total_employeur?: number;
    pdf_page_number_start?: number;
    pdf_page_number_end?: number;
    files: Array<any> = [];
    excel_file?: any;
    created_at?: string;
    updated_at?: string;

    constructor(data: any) {
        _.assign(this, _.omit(data, ["employe", "files", "excel_file"]));
        if (data.employe) {
            this._employe = new Employe(data.employe);
        }
        if (data.files) {
            this.files = data.files;
        }
        if (data.excel_file) {
            this.excel_file = data.excel_file;
        }
    }

    // Employe getter/setter
    get employe(): Employe | undefined {
        return this._employe;
    }

    set employe(value: Employe | undefined) {
        if (value) {
            this._employe = value;
            this.employe_id = value.id;
        }
    }

    // Date formatting getters
    get month_str(): string {
        if (this.month) {
            return DateUtils.sqlToDateStr(this.month, "MM/YYYY");
        } else {
            return "";
        }
    }

    get creation_date_str(): string {
        if (this.created_at) {
            return DateUtils.sqlToDateStr(this.created_at, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    // Serialize method for API calls
    serialize(): BulletinDeSalaire.IBulletinDeSalaire {
        return {
            id: this.id,
            employe_id: this.employe_id,
            month: this.month,
            total_brut: this.total_brut,
            total_net: this.total_net,
            total_employeur: this.total_employeur,
            pdf_page_number_start: this.pdf_page_number_start,
            pdf_page_number_end: this.pdf_page_number_end,
        };
    }
}

// Interface for serialization
export namespace BulletinDeSalaire {
    export interface IBulletinDeSalaire {
        id?: number;
        employe_id?: number;
        month?: string;
        total_brut?: number;
        total_net?: number;
        total_employeur?: number;
        pdf_page_number_start?: number;
        pdf_page_number_end?: number;
    }
}
